module.exports = __webpack_public_path__ + "img/whatsapp-preview.5ec59e76.png";